export default "__VITE_ASSET__db4fb6e8__"